module.exports = __webpack_public_path__ + "img/next-icon.2040f371.svg";